import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Modal} from "../../../../../../components/modal/modal.jsx";
import {useQuery} from "@tanstack/react-query";
import ecapTemplateService from "../../../../../../services/web/ecap-template-service.js";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../components/button/button.jsx";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {FaEraser, FaPen, FaPlus, FaSearch} from "react-icons/fa";

const EcapTemplateModal = ({open, setOpen}) => {
    const navigate = navigateHook();

    const [state, setState] = useState("");
    const [data, setData] = useState([]);

    const {data: template, isSuccess} = useQuery({
        queryFn: () => ecapTemplateService.list(),
        queryKey: ["templates-list"],
    });

    useEffect(() => {
        if (!isSuccess) return;

        setData(template);
    }, [isSuccess]);

    const gridRef = useRef(undefined);

    const [columnDefs,] = useState([
        {headerName: "Nome", field: "name", flex: 1, sort: "asc", comparator: aggridUtils.nullLastComparator},
        {
            headerName: "Ações",
            field: "",
            sortable: false,
            cellRenderer: ({data}) => (
                <div className="h-full content-center place-items-center w-full">
                    <Button className={"!h-[25px]"} onClick={() => navigate(`/ecap-template/form/${data.id}`)} title={"Editar"}>
                        <FaPen />
                    </Button>
                </div>
            ),
            width: 80
        }
    ]);

    const apply = useCallback(() => {
        if (!state) return;

        setData(template.filter(t => t.name.toLowerCase().includes(state.toLowerCase())));
    }, [state, template]);

    const clear = useCallback(() => {
        setState("");
        setData(template);
    }, [template]);

    return (
        <Modal open={open} setOpen={setOpen} title={"Modelos"}>
            <Modal.Body className={"space-y-2"}>
                <div className="flex justify-between gap-4">
                    <InputForm
                        classNameWrapper={"w-full"}
                        id={"name"}
                        label={"Nome"}
                        name={"name"}
                        value={state}
                        onChange={({target: {value}}) => setState(value)}
                    />

                    <div className={"flex gap-2"}>
                        <Button target={"default"} onClick={clear} title={"Limpar"}>
                            <FaEraser />
                        </Button>
                        <Button onClick={apply} title={"Buscar"}>
                            <FaSearch />
                        </Button>
                        <Button onClick={() => navigate(`/ecap-template/form`)}>
                            <FaPlus /> Adicionar
                        </Button>
                    </div>
                </div>

                <div className="ag-theme-quartz" style={{height: "calc(100vh - 275px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={data}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        suppressRowVirtualisation={true}
                        suppressColumnVirtualisation={true}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default EcapTemplateModal;